// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"BookingConfirmation_checkboxWrapper__CJ9ul","checkbox":"BookingConfirmation_checkbox__2HHnh","agreementText":"BookingConfirmation_agreementText__2XhIF"};